import { Component, DoCheck } from '@angular/core';
import { BaseComponent } from '../../abstract/base.component';
import { Router } from '@angular/router';

/**
 * Bare-bones route shell for `/subscription/*`. Each child screen renders its own
 * `payarc-page-header` + (for the 5 list-type screens) `<app-subscription-tabs>`,
 * matching how the prototype builds each page rather than a shared chrome —
 * same dissolution as `ZenDeskComponent` (see PENDING-FINDINGS.md).
 */
@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.css'],
    standalone: false
})
export class SubscriptionComponent extends BaseComponent implements DoCheck {
  constructor(_router: Router) {
    super();
    this.router = _router;
  }

  ngDoCheck() {
    if (location.pathname === '/subscription') {
      this.routeNavigate('/subscription/subscription-list');
    }
  }
}
